export const convertJourneysToArray = journeysObj => {
    if (!journeysObj || !Object.keys(journeysObj).length) {
        return [];
    }

    return Object.entries(journeysObj).map(([name, obj]) => ({ name, ...obj }));
};
